import { render, staticRenderFns } from "./palet.vue?vue&type=template&id=5156fda8&"
import script from "./palet.vue?vue&type=script&lang=ts&"
export * from "./palet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports